<template>
  <b-container id="last-update">
    <b-row v-if="lastUpdateActLog && Object.keys(lastUpdateActLog).length != 0">
      <b-col cols="10" class="last-update-text">
        {{ $t('message.last_update') | title}}:
        {{ lastUpdateActLog.username }}, {{ lastUpdateActLog.type.substring(6) }},
        {{ lastUpdateActLog.start_date }} ({{ $t('message.last_update_system_time') }}),
          {{$t('message.business_result_' + lastUpdateActLog.business_result)}}
      </b-col>
      <b-col>
        <a v-if="showFullLink" href="/padmin/#/general_script/logs/full_padmin_activity"
          target="_blank" id="details-link">
          {{ $t('message.last_update_details') | title}}
        </a>
      </b-col>
    </b-row>
    <b-row v-if="lastUpdateActLog" id="last-update-details" class="last-update-text">
      <b-col cols="10">
        {{$t("message.last_update_params") | title}}:
      </b-col>
    </b-row>
    <div v-if="lastUpdateActLog && lastUpdateActLog.details">
      <b-row v-for="detailRow in lastUpdateActLog.details.split(',')">
        <b-col cols="10" offset="1" class="last-update-text">
          {{ detailRow }}
        </b-col>
      </b-row>
    </div>
    <b-row v-if="lastUpdateActLog && lastUpdateActLog.comment" class="last-update-text">
      <b-col cols="10">
        {{$t('message.comment')}}: <pre id="last-update-details-comment">{{lastUpdateActLog.comment}}</pre>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { get } from "../http"

export default {
  name: "LastUpdateInfo",

  props: {
    scriptName: String
  },

  data() {
    return {
      lastUpdateActLog: {}
    }
  },

  mounted() {
    this.getLastRun()
  },

  methods: {
    getLastRun() {
      this.lastUpdateActLog = null
      get('/last_update').then(resp => {
        this.lastUpdateActLog = resp.data.act_log
        this.showFullLink = resp.data.can_access_full_log
      },
      err => {
        console.log(err)
      })
    }
  }
}
</script>
<style>
  .last-update-text {
    text-align: left;
  }
  #last-update {
    margin-top: 40px;
  }
  #last-update-details {
    margin-top: 20px;
  }
  #last-update-details-comment {
    margin-left: 40px;
  }

</style>
